import { render, staticRenderFns } from "./ScreenInfo.vue?vue&type=template&id=0997e82a&scoped=true"
import script from "./ScreenInfo.vue?vue&type=script&lang=js"
export * from "./ScreenInfo.vue?vue&type=script&lang=js"
import style0 from "./ScreenInfo.vue?vue&type=style&index=0&id=0997e82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0997e82a",
  null
  
)

export default component.exports